<h1>Disclosures</h1>
<span class="messages">
    <img src="/wp-content/themes/swarm/app/assets/images/loading.gif" *ngIf="loading" class="loader">
    <span class="save-text" *ngIf="saved"><mat-icon>check</mat-icon> Saved!</span>
    <span class="error-text" *ngIf="error"><mat-icon>error_outline</mat-icon> {{error}} </span>
    <span class="editor-text" *ngIf="canEdit && disclosuresEditor"> {{disclosuresEditor}} is currently editing <button type="button" class="button small" (click)="setLock('update')">Take Over</button></span>
</span>
<div>
    <div class="input-wrap search">
        <label for="disclosure">Affiliate Disclosure</label> 
        <textarea 
            #disclosureEl
            name="disclosure" 
            id="disclosure" 
            [formControl]="textareaControl"
            placeholder="{{ placeholder }}" 
            (input)="resetError()" 
            (blur)="save()">
        </textarea>
    </div>
</div>